import { Button } from '@mui/material'
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { baseUrl } from '../../../../Config/baseUrl';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';

const AddSpesficProjectDetails = () => {


    const { id } = useParams()
    const { state } = useLocation();
    const { type } = useParams();


    console.log("dsghsdghsdghs", type)
    const [data, setData] = useState();
    const [category, setCategory] = useState();
    const navegate = useNavigate();


    const [fields, setFields] = useState([""]);

    const handleInputChange = (index, value) => {
        const updatedFields = [...fields];
        updatedFields[index] = value;
        setFields(updatedFields);
    };

    const handleAddField = (e) => {
        e.preventDefault();
        setFields([...fields, ""]);  // Adds a new empty string field
    };

    const handleDeleteField = (index, e) => {
        e.preventDefault();
        const updatedFields = fields.filter((_, i) => i !== index);
        setFields(updatedFields);
    };


    const getProject = () => {
        axios
            .get(`${baseUrl}/blog/projectlist-api/`, {

                params: {

                    projectlist_id: state,
                },
                headers: {
                    Authorization: `Token ${localStorage.getItem("token")}`,
                    "Access-Control-Allow-Origin": "*",
                },
            })
            .then((res) => {
                console.log("RESPONSE ==== : ", res.data);
                setData(res.data?.data);
                // handleEdit(res.data?.news_details);
            })
            .catch((err) => {
                console.log("ERROR: ====", err);
                toast.error(err.message);
            });
    };

    useEffect(() => {
        state && getProject();
    }, [state]);


    useEffect(() => {
        data?.description && setFields(data?.description)
    }, [data])

    console.log(data);

    const formik = useFormik({
        initialValues: {
            title: data?.title || "",
            image: data?.image || "",
            // description: fields
        },
        enableReinitialize: true,
        onSubmit: (values) => {
            console.log("1111111111111SSS>>>>>>>>>>>><<<>>??>>", values?.title)
            const formBd = new FormData();
            formBd.append("title", values.title);
            formBd.append("store", localStorage.getItem("store_id"));
            formBd.append("image", values.image);
            formBd.append("description", JSON.stringify(fields));
            formBd.append("project", id)
            // formBd.append("store", localStorage.getItem("store_id"))


            console.log("wetywertywetysdtysdgysdydf", ...formBd)
            type === "update" && formBd.append("projectlist_id", state);
            type === "add"
                ?
                axios
                    .post(
                        `${baseUrl}/blog/projectlist-api/`,
                        formBd,
                        {
                            headers: {
                                Authorization: `Token ${localStorage.getItem("token")}`,
                                "Content-Type": "multipart/form-data",
                            },
                        }
                    )
                    .then((response) => {
                        toast.success(response.data.message);
                        navegate(`/projectdetails/${id}`);
                    })
                    .catch((error) => {
                        toast.error("Error adding blog:", error);
                    })
                :

                axios
                    .patch(`${baseUrl}/blog/projectlist-api/`, formBd, {
                        // data: {
                        //     project_image_id: formBd,
                        // },
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization: `Token ${localStorage.getItem("token")}`,
                        },
                    })
                    .then((response) => {
                        toast.success(response.data.message);
                        navegate(-1);
                    })
                    .catch((error) => {
                        console.error("Error adding blog:", error);
                    });
        },
    });

    // const blogData = () => {
    //     axios
    //         .get(`${baseUrl}/blog/projectlist-api/`, {
    //             headers: {
    //                 Authorization: `Token ${localStorage.getItem("token")}`,
    //                 "Access-Control-Allow-Origin": "*",
    //             },
    //         })
    //         .then((res) => {


    //             console.log("responseeeeeeeeeeeee", res)
    //             setCategory(res?.data?.data);
    //         })
    //         .catch((err) => {
    //             toast.error(err.response?.data.message);
    //         });
    // };
    // useEffect(() => {
    //     blogData();
    // }, []);
    console.log("Titlle0", formik.values?.title)
    return (
        <div className="flex flex-col justify-center gap-5 py-4 lg:flex-row">
            <div className="flex flex-col justify-center w-full lg:w-3/5">
                <div className="mt-5 bg-white shadow-lg">
                    <form

                        className='px-10'


                        onSubmit={formik.handleSubmit}

                    >







                        <div className="w-full pl-3 ">
                            <div>
                                <p className="p-1 text-sm font-semibold">title</p>
                                <input
                                    id="title"
                                    name='title'
                                    placeholder="Enter title"
                                    value={formik.values.title}
                                    className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
                                    onChange={formik.handleChange}
                                />
                            </div>
                        </div>

                        {fields.map((field, index) => (

                            <div className="w-full pl-3 ">
                                <div key={index}>
                                    <p className="p-1 text-sm font-semibold">Discription</p>

                                    <div className="flex w-full">
                                        <input
                                            id="meta_title"
                                            placeholder="Enter Discription"
                                            value={field}
                                            className="w-[95%] p-2 px-4 m-1 border border-gray-300 rounded"
                                            onChange={(e) => handleInputChange(index, e.target.value)}
                                        />
                                        <div className=" w-[5%] flex items-center">
                                            {index === fields.length - 1 ? (
                                                <button className="w-8 h-8 text-xl text-white bg-blue-700 rounded-full" onClick={handleAddField}>+</button>
                                            ) : (
                                                <button className="w-8 h-8 text-xl text-white bg-blue-700 rounded-full" onClick={(e) => handleDeleteField(index, e)}>-</button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        <div className="w-full pl-3 ">
                            <div>
                                <p className="p-1 text-sm font-semibold">Image</p>
                                <input
                                    id="images"
                                    type="file"
                                    required
                                    className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
                                    onChange={(event) =>
                                        formik.setFieldValue("image", event.target.files[0])
                                    }
                                />
                            </div>
                        </div>





                        {type === "update" ? (<div className="w-full pl-3 ">
                            <Button type="submit" variant="contained">
                                Update
                            </Button>
                        </div>) : (
                            <div className="w-full pl-3 ">
                                <Button type="submit" variant="contained">
                                    Add
                                </Button>
                            </div>)}






                    </form>
                </div>
            </div>
        </div>
    )
}

export default AddSpesficProjectDetails